import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_ConsumerRights = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_ConsumerRights' className='file-pdf-document'>
            <div className='file-template'>
                <p>1. Consumer Rights Policy and DMH Consumer Rights Statement; and </p>
                <p>2. HIPAA Privacy Rules for the Protection of Health and Mental Health Information</p>
                <p>
                    I acknowledge that I received:  <br /> <br />
                    <input type="checkbox" name="cbConsumerRights_1" id="cbConsumerRights_1" className='add-only' value="ConsumerRights_1" />Consumer Rights Policy and DMH Consumer Rights Statement <br />
                    <input type="checkbox" name="cbConsumerRights_2" id="cbConsumerRights_2" className='add-only' value="ConsumerRights_2" />HIPAA Privacy Rules for the Protection of Health and Mental Health Information <br /> <br />
                    My signature below acknowledges that I have received a copy of both the Life Solutions South, LLC. <br />
                    <strong>Consumer Rights Policy</strong>  and the <strong>DMH Consumers Rights Statement</strong> and that I have received a copy of
                    the <strong>HIPAA Privacy Rules for the Protection of health and Mental Health Information.</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750 small">Client Name (Printed):</td>
                    </tr>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750 small">Client Signature:</td>
                    </tr>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750 small">Parent/Legal Guardian Signature:</td>
                    </tr>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750 small">Date:</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Reason for Refusal to sign:</span>
                    <textarea id="txtConsumerRights_1" name="txtConsumerRights_1" className='add-only'></textarea>
                </p>
            </div>
        </form>
    )
}